export default __webpack_public_path__ + "static/media/sbs-project.922d9565.jpg";